import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-heart\">\n  <path d=\"M3 9.919C3 5.54816 8.19577 3.26253 11.4178 6.21602L12 6.74974L12.5822 6.21602C15.8042 3.26253 21 5.54816 21 9.919C21 11.2513 20.4708 12.529 19.5287 13.471L12.2186 20.7812C12.0979 20.9019 11.9021 20.9019 11.7814 20.7812L4.47131 13.471C3.52925 12.529 3 11.2513 3 9.919Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol